import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { Theme } from "@radix-ui/themes";

import { App } from "./App";
import "@radix-ui/themes/styles.css";
import "./styles.css";

const root = document.getElementById("root");
if (!root) throw new Error("Tayan yönetim paneli kök öğesi bulunamadı.");
createRoot(root).render(
  <StrictMode>
    <Theme appearance="dark" accentColor="indigo" grayColor="slate" radius="large" scaling="100%">
      <App />
    </Theme>
  </StrictMode>,
);
